import type { SVGProps } from 'react';
import { cn } from '@/lib/utils';
import { icons, type IconName, type SvgIconComponent } from './registry';

export type IconProps = {
  name: IconName;
  className?: string;
  /** Accessible label; omit for decorative icons (default). */
  title?: string;
} & Omit<SVGProps<SVGSVGElement>, 'ref'>;

export function Icon({ name, className, title, ...props }: IconProps) {
  const Svg = icons[name];
  const decorative = !title;

  return (
    <Svg
      {...props}
      className={cn('shrink-0', className)}
      aria-hidden={decorative ? true : undefined}
      role={decorative ? undefined : 'img'}
      aria-label={title}
    />
  );
}

export function getIconComponent(name: IconName): SvgIconComponent {
  return icons[name];
}
